import { z } from 'zod';

/**
 * Tenant-owned legal entity used to brand locally generated documents.
 * Legal document renderers may deliberately use only `logo_data_uri` when the
 * immutable document payload remains the source of truth for issuer details.
 */
export const documentIssuerSchema = z.object({
  company_id: z.string(),
  name: z.string(),
  address_lines: z.array(z.string()),
  vat_number: z.string().nullable(),
  fiscal_code: z.string().nullable(),
  email: z.string().nullable(),
  pec: z.string().nullable(),
  phone: z.string().nullable(),
  logo_data_uri: z.string().nullable(),
});

export type DocumentIssuer = z.infer<typeof documentIssuerSchema>;